export const localeCountryCodeMap: {
  [key: string]: { name: string; isBeta?: boolean; isNew?: boolean };
} = {
  cimode: {
    name: 'Dev (Only keys)',
  },
  en: {
    name: 'English',
  },
  'en-STAGING': {
    name: 'English (Staging)',
  },
  'pt-BR': {
    isBeta: true,
    name: 'Português (BR)',
  },
  'pt-STAGING': {
    name: 'Português (Staging)',
  },
  fr: {
    name: 'Français',
  },
  'fr-STAGING': {
    name: 'Français (Staging)',
  },
  de: {
    isNew: true,
    name: 'Deutsch',
  },
  'de-STAGING': {
    name: 'Deutsch (Staging)',
  },
  es: {
    isNew: true,
    name: 'Español',
  },
  'es-STAGING': {
    name: 'Español (Staging)',
  },
  nl: {
    name: 'Dutch',
  },
  'nl-STAGING': {
    name: 'Dutch (Staging)',
  },
};
